import { __rest } from "tslib";
import Checkbox from 'antd/lib/checkbox';
import Radio from 'antd/lib/radio';
import React from 'react';
import SelectAntDesign from 'antd/lib/select';
import { connectField, filterDOMProps } from 'uniforms';
import wrapField from './wrapField'; // SelectAntD does not recognize prop 'name'

var SelectAntD = SelectAntDesign;

var renderCheckboxes = function renderCheckboxes(props) {
  return React.createElement((props.fieldType === Array ? Checkbox : Radio).Group, Object.assign({
    disabled: props.disabled,
    id: props.id,
    name: props.name,
    onChange: props.fieldType === Array ? function (value) {
      return props.onChange(value);
    } : function (event) {
      return props.onChange(event.target.value);
    },
    options: props.allowedValues.map(function (value) {
      return {
        label: props.transform ? props.transform(value) : value,
        value: value
      };
    }),
    value: props.value
  }, filterDOMProps(props)));
};

var renderSelect = function renderSelect(props) {
  return React.createElement(SelectAntD, Object.assign({
    allowClear: !props.required,
    disabled: props.disabled,
    id: props.id,
    mode: props.fieldType === Array ? 'multiple' : undefined,
    name: props.name,
    onChange: function onChange(value) {
      return props.onChange(value);
    },
    placeholder: props.placeholder,
    ref: props.inputRef,
    value: props.fieldType === Array ? props.value ? props.value.filter(function (value) {
      return value !== undefined;
    }) : [] : props.value
  }, filterDOMProps(props)), props.allowedValues.map(function (value) {
    return React.createElement(SelectAntD.Option, {
      key: value,
      value: value
    }, props.transform ? props.transform(value) : value);
  }));
};

var Select = function Select(_a) {
  var checkboxes = _a.checkboxes,
      props = __rest(_a, ["checkboxes"]);

  return wrapField(props, checkboxes ? renderCheckboxes(props) : renderSelect(props));
};

export default connectField(Select, {
  ensureValue: false
});